import {useState} from 'react'

import {HeroPagination, type HeroPaginationProps} from './HeroPagination/HeroPagination'
import {HeroSequence, type HeroSequenceProps} from './HeroSequence/HeroSequence'

import Styles from './Hero.module.css'

export interface HeroProps {
  heroSequence: Omit<HeroSequenceProps, 'currentChapterIndex' | 'onNextChapter' | 'onReady'>
  heroPagination: Omit<HeroPaginationProps, 'onChange' | 'items' | 'currentChapterIndex'> & {
    items: string[]
  }
}

export const defaultProps: Partial<HeroProps> = {}

export const Hero = (props: HeroProps) => {
  const initializedProps: HeroProps = {...defaultProps, ...props}
  const {heroSequence, heroPagination} = initializedProps

  const [currentChapterIndex, setCurrentChapterIndex] = useState<number>(0)
  const [chapterDurations, setChapterDurations] = useState<number[]>([])

  return (
    <div className={Styles['Hero']}>
      <HeroSequence
        {...heroSequence}
        currentChapterIndex={currentChapterIndex}
        onNextChapter={setCurrentChapterIndex}
        onReady={setChapterDurations}
      />
      <HeroPagination
        {...heroPagination}
        currentChapterIndex={currentChapterIndex}
        onChange={setCurrentChapterIndex}
        items={heroPagination.items.map((label, index) => ({
          label,
          duration: chapterDurations[index] ?? 0,
        }))}
      />
    </div>
  )
}
